module.exports = global["$"] = require("-!/home/arbeit/Dokumente/GitHub/plugin-eros/node_modules/expose-loader/index.js?jQuery!./jquery.js");